/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Optout_Signal_NoteInputs */

const en_bot_optout_signal_note = /** @type {(inputs: Bot_Optout_Signal_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With Content-Signal ai-input=no, BystepBot stops the analysis before any text is sent to an AI model.`)
};

const id_bot_optout_signal_note = /** @type {(inputs: Bot_Optout_Signal_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dengan Content-Signal ai-input=no, BystepBot menghentikan analisis sebelum ada teks yang dikirim ke model AI.`)
};

/**
* | output |
* | --- |
* | "With Content-Signal ai-input=no, BystepBot stops the analysis before any text is sent to an AI model." |
*
* @param {Bot_Optout_Signal_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_optout_signal_note = /** @type {((inputs?: Bot_Optout_Signal_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Optout_Signal_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_optout_signal_note(inputs)
	return en_bot_optout_signal_note(inputs)
});